export const styles = (theme) => ({
  margin: {
    margin: theme.spacing(1),
    padding: "0px 24px",
    minWidth: "800px",
    maxWidth: "100%",
    [theme.breakpoints.down("md")]: {
      minWidth: "100% !important;",
    },
  },

  root: {
    width: "433px",
    [theme.breakpoints.down("md")]: {
      marginTop: "0px !important",
    },
  },
  success: {
    borderRadius: "4px",
    backgroundColor: "#86c454",
    [theme.breakpoints.down("md")]: {
      marginTop: "0px !important",
      borderRadius: "0",
    },
  },
  error: {
    backgroundColor: "#ec7474",
    [theme.breakpoints.down("md")]: {
      marginTop: "0px !important",
    },
  },
  info: {
    backgroundColor: "#479dff", //theme.palette.primary.dark,
    [theme.breakpoints.down("md")]: {
      marginTop: "0px !important",
    },
  },
  warning: {
    //backgroundColor: amber[700],
    backgroundColor: "#ed4e61",
    [theme.breakpoints.down("md")]: {
      marginTop: "0px !important",
    },
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
  close: {
    [theme.breakpoints.down("md")]: {
      display: "flex",
      padding: "0px !important",
    },
  },
  messageText: {
    color: "white",
    fontWeight:"500",
  }
});
